import { Component, OnInit, Input } from '@angular/core';
import { BaggageItem } from '../../shared';

@Component({
  selector: 'app-baggage-info',
  templateUrl: './baggage-info.component.html',
  styleUrls: ['./baggage-info.component.css']
})
export class BaggageInfoComponent implements OnInit {
  @Input() baggage_items: Array<BaggageItem>;

  small_bag = false;
  cabin_bag = false;
  large_bag = false;

  displayText: string = '';

  constructor() {}

  // Helper method to get baggage item by type
  getBaggageItemByType(type: number): BaggageItem | undefined {
    if (!this.baggage_items) return undefined;
    return this.baggage_items.find(item => item.type === type);
  }

  // Helper method to check if baggage is included
  isIncluded(qty: number): boolean {
    return qty !== 0 && qty !== null && qty !== undefined;
  }

  ngOnInit() {
    const smallBagItem = this.getBaggageItemByType(0);
    const largeCabinBagItem = this.getBaggageItemByType(1);
    const checkedBagItem = this.getBaggageItemByType(2);

    const hasSmallBag = smallBagItem && this.isIncluded(smallBagItem.qty);
    const hasLargeCabinBag = largeCabinBagItem && this.isIncluded(largeCabinBagItem.qty);
    const hasCheckedBag = checkedBagItem && this.isIncluded(checkedBagItem.qty);

    if (hasSmallBag && !hasLargeCabinBag && !hasCheckedBag) {
      this.small_bag = true;
      this.displayText = 'Small Bag only';
    }
    if (hasSmallBag && hasLargeCabinBag && !hasCheckedBag) {
      this.cabin_bag = true;
      this.displayText = 'Cabin Bags only';
    } else if (hasSmallBag && hasLargeCabinBag && hasCheckedBag) {
      this.large_bag = true;
      if (checkedBagItem.unit === 'KG') {
        this.displayText += '1';
      } else if (checkedBagItem.qty > 0) {
        this.displayText += checkedBagItem.qty.toString();
      } else {
        this.displayText += '1';
      }

      if (
        checkedBagItem.qty > 1 &&
        checkedBagItem.unit !== 'KG'
      ) {
        this.displayText += ' Checked Bags';
      } else {
        this.displayText += ' Checked Bag';
      }
    }
  }
}
